import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useTaskBookStore } from "../../../../Store/TaskBookStore/TaskBookStore";

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: "37px",
    minHeight: "37px",
    width: "200px",
    fontSize: "13px",
    fontFamily: "Inter",
    fontWeight: "400",
  }),
};

export default function Selector({ options, property }) {
  const { updateParams, getSubjectDetails, queryParams, setLoading } =
    useTaskBookStore();

  const { t } = useTranslation();

  const handleSelectChange = useCallback(async (e) => {
    setLoading(true);
    if (property === t("Guruh turlari")) {
      updateParams({
        age_group: e?.value == undefined ? "" : e?.value,
        page: 1,
      });
      await getSubjectDetails(
        new URLSearchParams({
          ...queryParams,
          age_group: e?.value == undefined ? "" : e?.value,
          page: 1,
        }).toString()
      );
    }
    if (property === t("Oylar")) {
      updateParams({ month: e?.value == undefined ? "" : e?.value, page: 1 });
      await getSubjectDetails(
        new URLSearchParams({
          ...queryParams,
          month: e?.value == undefined ? "" : e?.value,
          page: 1,
        }).toString()
      );
    }
    setLoading(false);
  });

  return (
    <div className="normal-select-bar">
      <Select
        className="basic-single manage_group_select"
        classNamePrefix="select"
        placeholder={property}
        styles={customStyles}
        options={options}
        isClearable
        onChange={handleSelectChange}
      />
    </div>
  );
}
